import Link from 'components/UI/Link';
import { ReactElement } from 'react-markdown';
interface LinkWithIconProps {
  text: string;
  slug?: string;
  icon?: string;
}

export default function LinkWithIcon({ text, slug, icon }: LinkWithIconProps): ReactElement {
  const Icon = (): ReactElement | null => {
    switch (icon) {
      case 'eye':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M0.833008 9.99967C0.833008 9.99967 4.16634 3.33301 9.99967 3.33301C15.833 3.33301 19.1663 9.99967 19.1663 9.99967C19.1663 9.99967 15.833 16.6663 9.99967 16.6663C4.16634 16.6663 0.833008 9.99967 0.833008 9.99967Z"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case 'location':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <g clipPath="url(#clip0_3592_279)">
              <path
                d="M17.5 8.33301C17.5 14.1663 10 19.1663 10 19.1663C10 19.1663 2.5 14.1663 2.5 8.33301C2.5 6.34388 3.29018 4.43623 4.6967 3.02971C6.10322 1.62318 8.01088 0.833008 10 0.833008C11.9891 0.833008 13.8968 1.62318 15.3033 3.02971C16.7098 4.43623 17.5 6.34388 17.5 8.33301Z"
                stroke="white"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 10.833C11.3807 10.833 12.5 9.71372 12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61929 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71372 8.61929 10.833 10 10.833Z"
                stroke="white"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_3592_279">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      default:
        return null;
    }
  };

  function LinkTag({
    hasLink,
    slug,
    children,
  }: {
    hasLink: boolean;
    slug: string;
    children: React.ReactNode;
  }): ReactElement {
    if (hasLink) {
      return <Link slug={`${slug}`}>{children}</Link>;
    }
    return <span>{children}</span>;
  }

  return (
    <LinkTag hasLink={!!slug} slug={`${slug}`}>
      <a className="text-lg teal-fontcolor hover:text-primary-actual bg-neutral-alt hover:bg-neutral-alt/30 p-2.5 flex items-center justify-start gap-3 h-full">
        <div className="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center">
          {Icon()}
        </div>
        <span className="flex-grow">{text}</span>
        {slug && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="19"
            viewBox="0 0 11 19"
            fill="none"
          >
            <path
              d="M1.33301 1.33301L9.33301 9.33301L1.33301 17.333"
              stroke="#00C1D4"
              strokeWidth="2.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </a>
    </LinkTag>
  );
}
